import React from 'react'

import { useColor, useColors } from '../../packages/kiti/components/theme/_hooks/colors'
import { useShouldHideColors } from './options/_form/PdfOptionsFormHandler'

const Line = ({ height, width, vertical, color, align }) => {
  const hideColors = useShouldHideColors()
  const colors = useColors()
  color = useColor(color || 'light2')
  height = height || (vertical ? '100%' : '1px')
  width = width || (!vertical ? '100%' : '1px')

  const style = {
    height,
    width,
    backgroundColor: hideColors ? colors.black + '22' : color,
    margin: '0 auto'
  }

  return <div className="line" style={style} />
}

export default Line
